import * as deepmergeImport from 'deepmerge';
import * as getValueImport from 'get-value';
import * as hashObjectImport from 'object-hash';
import * as setValueImport from 'set-value';

const interopDefault = <T>(module: T): T =>
  ((module as { default?: T }).default ?? module) as T;

export const getValue: any = interopDefault(getValueImport as any);
export const setValue: any = interopDefault(setValueImport as any);
export const deepmerge: any = interopDefault(deepmergeImport as any);
export const hashObject: any = interopDefault(hashObjectImport as any);
